<template>
  <div class="adaptation-plan-upload">
    <!-- <div class="component-title">Upload your Adaptation Plan</div> -->

    <div class="row grid">
      <div class="col s12">
        <div
          v-for="(item, key, index) in documents"
          :key="index"
          class="file-row col s12"
        >
          <div class="left flex-text">
            <div class="preview-item" v-if="item.link">
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 512 512"
                style="enable-background:new 0 0 512 512;"
                xml:space="preserve"
              >
                <path
                  style="fill:#E2E5E7;"
                  d="M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
                />
                <path
                  style="fill:#B0B7BD;"
                  d="M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
                />
                <polygon
                  style="fill:#CAD1D8;"
                  points="480,224 384,128 480,128 "
                />
                <path
                  style="fill:#F15642;"
                  d="M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16
	V416z"
                />
                <g>
                  <path
                    style="fill:#FFFFFF;"
                    d="M101.744,303.152c0-4.224,3.328-8.832,8.688-8.832h29.552c16.64,0,31.616,11.136,31.616,32.48
		c0,20.224-14.976,31.488-31.616,31.488h-21.36v16.896c0,5.632-3.584,8.816-8.192,8.816c-4.224,0-8.688-3.184-8.688-8.816V303.152z
		 M118.624,310.432v31.872h21.36c8.576,0,15.36-7.568,15.36-15.504c0-8.944-6.784-16.368-15.36-16.368H118.624z"
                  />
                  <path
                    style="fill:#FFFFFF;"
                    d="M196.656,384c-4.224,0-8.832-2.304-8.832-7.92v-72.672c0-4.592,4.608-7.936,8.832-7.936h29.296
		c58.464,0,57.184,88.528,1.152,88.528H196.656z M204.72,311.088V368.4h21.232c34.544,0,36.08-57.312,0-57.312H204.72z"
                  />
                  <path
                    style="fill:#FFFFFF;"
                    d="M303.872,312.112v20.336h32.624c4.608,0,9.216,4.608,9.216,9.072c0,4.224-4.608,7.68-9.216,7.68
		h-32.624v26.864c0,4.48-3.184,7.92-7.664,7.92c-5.632,0-9.072-3.44-9.072-7.92v-72.672c0-4.592,3.456-7.936,9.072-7.936h44.912
		c5.632,0,8.96,3.344,8.96,7.936c0,4.096-3.328,8.704-8.96,8.704h-37.248V312.112z"
                  />
                </g>
                <path
                  style="fill:#CAD1D8;"
                  d="M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
                />
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
              </svg>
            </div>
            <div class="title left" v-html="item.text"></div>
          </div>
          <button
            class="btn btn-rounded amber lighten-1 z-depth-0 grey-text text-darken-3 right"
            @click="$_selectImage('add', item, key)"
            v-if="!item.link"
          >
            Add
          </button>
          <button
            class="btn btn-rounded amber lighten-1 z-depth-0 grey-text text-darken-3 right"
            @click="$_selectImage('update', item, key)"
            v-else
          >
            Edit
          </button>
          <div class="clear"></div>
        </div>
      </div>
      <edit-adaptation-modal
        v-if="openModal"
        :data-action="action"
        :data-documents="documents"
        @refresh="$_getData()"
        @close="$_reset()"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import editAdaptationModal from "./editAdaptationFile.vue";
export default {
  components: { editAdaptationModal },
  name: "AdaptationPlanUpload",
  data() {
    return {
      documents: [],

      openModal: false,
      action: null,
      selectedImage: null,
      selectedKey: null,
    };
  },
  mounted() {
    this.$_getData();
  },
  computed: {
    ...mapState({ user: (state) => state.User.user }),
  },
  methods: {
    $_getData() {
      const { adaptation_plan_document } = this.user;

      adaptation_plan_document
        ? (this.documents = JSON.parse(adaptation_plan_document))
        : (this.documents = [
            {
              text: "Upload Adaptation Plan",
              value: "",
              id: "",
              link: "",
              images: [],
            },
          ]);
    },
    $_reset() {
      this.openModal = false;
      this.action = null;
      this.selectedImage = null;
      this.selectedKey = null;
    },
    $_selectImage(actionType, image, key) {
      this.action = actionType;
      this.selectedImage = image;
      this.selectedKey = key;
      this.openModal = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.adaptation-plan-upload {
  // padding: 24px 18px;
  // background: #efefef;
  // margin: 16px 0px 0px;
  @media screen and (min-width: 768px) {
    // padding: 24px 20%;
  }
  .component-title {
    // padding: 0 10px 10px;
    font-size: 22px;
    // font-weight: 600;
  }
  .grid {
    .file-row {
      margin: 6px 0px;
      border-bottom: 1px solid #e2e2e2;
      padding: 0px 0px 8px;
    }
  }
  .flex-text {
    display: flex;
    .title {
      font-size: 16px;
    }
  }
  .preview-item {
    width: 36px;
    height: 36px;
    background-size: cover !important;
    margin-right: 8px;
    border-radius: 4px;
  }
}
</style>
